var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTimelineNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.07956V4.91804C0 4.56139 0.301166 4.26958 0.669257 4.26958H7.13873V0.649032C7.13873 0.0708243 7.85818 -0.215578 8.28205 0.189708L13.8034 5.53948C14.0655 5.79346 14.0655 6.20415 13.8034 6.45812L8.28205 11.8079C7.85818 12.2186 7.13873 11.9268 7.13873 11.3486V7.72802H0.669257C0.301166 7.72802 0 7.43621 0 7.07956Z",
    fill: "#19147E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTimelineNext);
export default __webpack_public_path__ + "static/media/arrow-timeline-next.422a40d5be373d833bbab576e64a2250.svg";
export { ForwardRef as ReactComponent };